function prepareLabel(name, label, required, bulkMode) {
  var _a;
  let newLabel = (_a = label !== null && label !== void 0 ? label : name) !== null && _a !== void 0 ? _a : '';
  const endsWithAsterisk = /(:?\*$|\*:$)/g.test(newLabel);
  const endsWithColon = /(:|\*:$)/g.test(newLabel);
  if (!endsWithColon) {
    newLabel = "".concat(newLabel, ":");
  }
  if (!endsWithAsterisk && required && newLabel[newLabel.length - 1] !== '*' && !bulkMode) {
    return "".concat(newLabel, "*");
  }
  return newLabel;
}

export { prepareLabel };
